export const font = {
  body: "Montserrat",
};
